import { render } from "./EntityManagement.vue?vue&type=template&id=c1dbc3be&scoped=true"
import script from "./EntityManagement.vue?vue&type=script&lang=js"
export * from "./EntityManagement.vue?vue&type=script&lang=js"

import "./EntityManagement.vue?vue&type=style&index=0&id=c1dbc3be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1dbc3be"]])

export default __exports__